import * as React from 'react';
export const IcAperture = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.11 6.16L15.5 8.82a.996.996 0 000 1.73l6.26 3.61c.15-.7.24-1.42.24-2.17 0-2.18-.71-4.19-1.89-5.84v.01zM12.5 8.24l6.26-3.61A9.97 9.97 0 0011 2.06v5.32c0 .77.83 1.25 1.5.87v-.01zM9 9.68V2.47c-.68.22-1.35.5-2 .87A9.931 9.931 0 002.89 7.9l4.61 2.66c.67.38 1.5-.1 1.5-.87v-.01zm-.5 3.75L2.24 9.82c-.15.7-.24 1.42-.24 2.17 0 2.18.71 4.19 1.89 5.84l4.61-2.66a.996.996 0 000-1.73v-.01zm3 2.31l-6.26 3.61A9.97 9.97 0 0013 21.92V16.6c0-.77-.83-1.25-1.5-.87v.01zM15 14.3v7.23c.68-.22 1.35-.5 2-.87a9.931 9.931 0 004.11-4.56l-4.61-2.66c-.67-.38-1.5.1-1.5.87v-.01z'
      fill='currentColor'
    />
  </svg>
);
